import React from "react"
import FieldInlineEditable from "../../../render/inline-editable";
import {FieldGlistEditableProps} from "../../../render/glist/glist-editable";

// const debug = "FieldProto_GListEditable"
// const debug = false

export default function FieldProto_GListEditable(props:FieldGlistEditableProps) {

    // debug && console.log(debug, "render()")

    // SMOTRI FieldTimeOfDay !!! on dolzen stat' proto ya dumau

    return <FieldInlineEditable field={props.field}
                                model={props.model}
                                onChange={props.onChange}
                                className={props.className} />

}
